"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migration_96_55_0 = void 0;
const echain_shared_articles_1 = require("@igus/echain-shared-articles");
/**
 * sets beschriftung of fixed end to beschriftung of moving end
 */
const migration_96_55_0 = (json) => {
    var _a;
    (_a = json.Leitungen) === null || _a === void 0 ? void 0 : _a.forEach((leitungJson) => {
        var _a;
        if (!((_a = leitungJson.ArticleSpecs) === null || _a === void 0 ? void 0 : _a.includes(echain_shared_articles_1.ArticleSpecs.Readycable))) {
            leitungJson.BeschriftungFixedEndText = leitungJson.BeschriftungText;
            leitungJson.BeschriftungFixedEnd = leitungJson.Beschriftung;
        }
    });
    return json;
};
exports.migration_96_55_0 = migration_96_55_0;
//# sourceMappingURL=migration_96_55_0.js.map